// Import the routing components.
import { Routes, Route, Navigate } from "react-router-dom";

import LoginPortal from "../components/auth/LoginPortal";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import AppLayout from "../components/layout/AppLayout";
import BulkTpsLookup from "../pages/BulkTpsLookup";
import CallsExplorer from "../pages/CallsExplorer";
import CreateUser from "../pages/CreateUser";
import Dashboard from "../pages/Dashboard/Dashboard";
import EditUser from "../pages/EditUser";
import Electralink from "../pages/Electralink";
import EmailGenerator from "../pages/EmailGenerator";
import GasLink from "../pages/Gaslink";
import InvoicePipeline from "../pages/InvoicePipeline";
import PageNotFound from "../pages/PageNotFound";
import ProposalDocuments from "../pages/ProposalDocuments";
import SalesDocumentsV2 from "../pages/SalesDocuments-v2";
import SingleTpsLookup from "../pages/SingleTpsLookup";
import { Transcription } from "../pages/Transcription";
import UsersList from "../pages/UsersList";

export const AppRoutes = () => (
  <Routes>
    {/* Public routes that are accessible without authentication */}
    <Route path="/login" element={<LoginPortal />} />

    {/* Protected routes that are only accessible once the user is authenticated */}
    {/* Route path directs to the dashboard page */}
    <Route path="/" element={<Navigate to="/dashboard" />} />

    <Route
      path="/dashboard"
      element={
        <ProtectedRoute pageId="dashboard">
          <AppLayout>
            <Dashboard />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/electralink-meter-search"
      element={
        <ProtectedRoute pageId="electralink-meter-search">
          <AppLayout>
            <Electralink />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/gas-meter-search"
      element={
        <ProtectedRoute pageId="gaslink-meter-search">
          <AppLayout>
            <GasLink />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/sales-documents-v2"
      element={
        <ProtectedRoute pageId="sales-documents-v2">
          <AppLayout>
            <SalesDocumentsV2 />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/transcription"
      element={
        <ProtectedRoute pageId="transcription">
          <AppLayout>
            <Transcription />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/single-tps-lookup"
      element={
        <ProtectedRoute pageId="single-tps-lookup">
          <AppLayout>
            <SingleTpsLookup />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/bulk-tps-lookup"
      element={
        <ProtectedRoute pageId="bulk-tps-lookup">
          <AppLayout>
            <BulkTpsLookup />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/proposal-documents"
      element={
        <ProtectedRoute pageId="proposal-documents">
          <AppLayout>
            <ProposalDocuments />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/invoice-pipeline"
      element={
        <ProtectedRoute pageId="invoice-pipeline">
          <AppLayout>
            <InvoicePipeline />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/calls-explorer"
      element={
        <ProtectedRoute pageId="calls-explorer">
          <AppLayout>
            <CallsExplorer />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/email-generator"
      element={
        <ProtectedRoute pageId="email-generator">
          <AppLayout>
            <EmailGenerator />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/admin/users"
      element={
        <ProtectedRoute pageId="admin-users">
          <AppLayout>
            <UsersList />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/admin/users/new"
      element={
        <ProtectedRoute pageId="admin-users">
          <AppLayout>
            <CreateUser />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path="/admin/users/:username"
      element={
        <ProtectedRoute pageId="admin-users">
          <AppLayout>
            <EditUser />
          </AppLayout>
        </ProtectedRoute>
      }
    />

    {/* Redirect any unknown paths to 'PageNotFound' page */}

    <Route path="*" element={<PageNotFound />} />
  </Routes>
);
